import HCheckArray from "@rf-helper/check-have-value";

import useAlert from "@rf-hooks/useAlert";
import useUserHasPermission from "@/shared/hooks/use-useris.hook";
import { useCallback, useEffect } from "react";
import { useController, useFormContext } from "react-hook-form";
import { CPropertyFormKeys } from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { I_GENERIC_ITEMS } from "@/src-refactor/modules/shared/model/interface/items.interface";
import { ownerAutoCompleteItem } from "@rf/adapters/autocomplete-items/ownerItemAdapters";

const useOwnerCheckConflict = () => {
  const { setValue, clearErrors } = useFormContext();

  const {
    field: { value }
  } = useController({
    name: CPropertyFormKeys.owners_property,
    defaultValue: []
  });

  const setOwnersValue = useCallback(
    (owners: I_GENERIC_ITEMS[]) => {
      setValue(CPropertyFormKeys.owners_property, owners, {
        shouldDirty: true,
        shouldTouch: true,
        shouldValidate: true
      });
      clearErrors(CPropertyFormKeys.owners_property);
    },
    [clearErrors, setValue]
  );

  const { USER_ROLE } = useUserHasPermission();
  const { alert } = useAlert();

  const handleOwnerConflicts = () => {
    if (!USER_ROLE.SUPER_ADMIN) return;
    if (HCheckArray(value)) {
      const items = (getOwners() as ownerAutoCompleteItem[]).slice();
      const ownerChecked = items.findIndex(
        x => x.extraData?.ownerData.requiredConflictEvaluation
      );
      if (ownerChecked !== -1) {
        alert({
          type: "warning",
          color: "warning.main",
          message: `${items[ownerChecked].extraData?.ownerData.name} tiene un indicador de conflicto, ¿Desea mantener la selección?`,
          confirmBtnMessage: "Sí",
          declineBtnMessage: "No"
        }).then(e => {
          if (e.type.confirm) {
            if (items[ownerChecked].extraData) {
              items[ownerChecked].extraData!.ownerData.requiredConflictEvaluation =
                false;
              console.log("items", items);
              setOwnersValue(items);
            }
          } else {
            items.splice(ownerChecked, 1);
            setOwnersValue(items);
          }
        });
      }
    }
  };

  const getOwners = () => {
    return value;
  };

  useEffect(() => {
    handleOwnerConflicts();
  }, [value.length]);

  return {
    showRedFlag: USER_ROLE.SUPER_ADMIN,
    // handleOwnerConflicts,
    getOwners,
    updateOwner: (owners: I_GENERIC_ITEMS[]) => setOwnersValue(owners)
  };
};

export default useOwnerCheckConflict;
